import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { formatCurrency, formatNumber, formatPercent } from '../utils/formatters';

const MetricCard = ({
  title,
  value,
  type = 'number',  // 'number', 'currency', 'percent'
  icon,
  trend,  // { value: 5.2, direction: 'up' or 'down' }
  subtitle,
  color = 'primary'
}) => {
  const formatValue = () => {
    switch (type) {
      case 'currency':
        return formatCurrency(value);
      case 'percent':
        return formatPercent(value);
      default:
        return formatNumber(value);
    }
  };

  const getTrendColor = () => {
    if (!trend) return '';
    return trend.direction === 'up' ? 'text-success' : 'text-danger';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend.direction === 'up' ? '↑' : '↓';
  };

  return (
    <Card className={`border-left-${color} shadow h-100`}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <CardTitle tag="h6" className="text-uppercase text-muted mb-0">
            {title}
          </CardTitle>
          {icon && <i className={`${icon} fa-2x text-gray-300`}></i>}
        </div>
        <div className="h3 mb-0 font-weight-bold text-gray-800">
          {formatValue()}
        </div>
        {trend && (
          <div className={`mt-2 ${getTrendColor()}`}>
            <small>
              {getTrendIcon()} {formatPercent(Math.abs(trend.value))} vs previous period
            </small>
          </div>
        )}
        {subtitle && (
          <div className="mt-2 text-muted">
            <small>{subtitle}</small>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default MetricCard;
